module.exports = __webpack_public_path__ + "static/media/new-arch.a5c70838.png";